import React from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../helpers/formatDate";
// import Dropdown from 'react-bootstrap/Dropdown';
// import {
//   IconZoom,
//   IconEdit,
//   IconTemplate,
//   IconUpload,
//   IconUsersGroup,
//   IconFileCertificate,
//   IconFileUpload,
//   IconBadge
// } from "@tabler/icons-react";
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import Dropdown from 'react-bootstrap/Dropdown';

const DatatableAccreditation = (props) => {
  // console.log(props);
  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: "Aksi",
      width: "200px",
      cell: (row) => (
        <>
          <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-basic" size="sm">
              Option
            </Dropdown.Toggle>
            <Dropdown.Menu
              renderOnMount
              popperConfig={{
                strategy: "fixed" // agar posisinya fixed, bukan absolute
              }}
            >

              <Dropdown.Item
                onClick={() => props.handleShowDetail(row)}
              >Detail</Dropdown.Item>

              {props.role === "Administrator" ? (
                <Dropdown.Item
                  onClick={() => props.handleEdit(row)}
                >Edit</Dropdown.Item>
              ) : (
                ""
              )}

              {row.active === "YES" && props.role !== "Administrator" ? (
                <Dropdown.Item
                  onClick={() =>
                    handleChangePage(`/chapter/${row.id}/${row.IdMasterAkreditasi}`)
                  }
                >Penilaian Mandiri</Dropdown.Item>
              ) : (
                ""
              )}

              {row.active === "YES" && props.role === "Administrator" &&
                row?.SyncSelfAssessment === "Ya" ? (
                <Dropdown.Item
                  onClick={() => props.handleUploadSelfAssesment(row)}
                >Import Self Assessment</Dropdown.Item>
              ) : (
                ""
              )}

              {row.active === "YES" && props.role !== "Administrator" &&
                props.role !== "Surveior External" && (
                  <Dropdown.Item
                    onClick={() =>
                      handleChangePage(`/forum/${row.id}/${row.IdMasterAkreditasi}`)
                    }
                  >Forum</Dropdown.Item>
                )}

              {row.active === "YES" && props.role !== "Administrator" ? (
                <Dropdown.Item
                  onClick={() => handleChangePage(`/pps/${row.id}`)}
                >Perencanaan Perbaikan Strategis (PPS)</Dropdown.Item>
              ) : (
                ""
              )}

              {props.role === "Administrator" && row.Hasil === null ? (
                <Dropdown.Item
                  onClick={() => props.handleSyncCapaian(row)}
                >Sync Capaian Akreditasi</Dropdown.Item>
              ) : (
                ""
              )}

              <Dropdown.Item
                onClick={() => props.handleExportAccumulation(row.id)}
              >Export Score Bab</Dropdown.Item>

              {row.active === "YES" && props.role === "Administrator" ? (
                <Dropdown.Item
                  onClick={() => props.handleUpload(row)}
                >Import Rekomendasi</Dropdown.Item>
              ) : (
                ""
              )}
            </Dropdown.Menu>
          </Dropdown>
        </>
      ),
    },
    {
      name: 'Capaian',
      cell: (row) => (
        <>
          {row.Hasil ? (
            <span className="badge bg-primary">{row.Hasil}</span>
          ) : (
            <span className="badge bg-warning">Belum Terakreditasi</span>
          )}
        </>
      ),
    },
    {
      name: "Standar",
      // selector: (row) => row?.standards_accreditation?.Nama,
      selector: (row) => (
        <span type="button" onClick={() => props.handleShowDetail(row)}>
          {row?.standards_accreditation?.Nama}
        </span>
      ),
    },
    {
      name: "Mulai Survei",
      selector: (row) => formatDate(row?.TglMulai),
    },
    {
      name: "Berakhir Survei",
      selector: (row) => formatDate(row?.TglBerakhir),
    },
    // {
    //   name: "Import SA",
    //   selector: (row) => (
    //     <span type="button" className="badge badge-info">
    //       {row?.SyncSelfAssessment}
    //     </span>
    //   ),
    // },
    {
      name: 'Active',
      cell: (row) => (
        <>
          {row.active === 'YES' ? (
            <span className="badge bg-success">YES</span>
          ) : (
            <span className="badge bg-danger">NO</span>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <h5 className="card-title">Daftar Kegiatan Akreditasi</h5>
      <DataTable
        columns={columns}
        data={props.modules}
        pagination
        fixedHeader
        highlightOnHover
        subHeader
        subHeaderComponent={
          <input
            type="text"
            placeholder="Search Periode Akreditasi"
            className="w-50 form-control m-3"
            values={props.search}
            onChange={(e) => {
              // Hanya izinkan huruf, angka, dan spasi
              const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
              props.handleChangeSearch(cleanValue);
            }}
          />
        }
        subHeaderAlign="center"
      />
    </>
  );
};

export default DatatableAccreditation;
